export default __webpack_public_path__ + "static/media/thu.44073d15.mp3";